import { useEffect, useRef, useState } from 'react';

/**
 * useCounterAnimation
 * @param {number} end - The final value to count to
 * @param {number} duration - Duration of the animation in ms
 * @returns {number} - The animated value
 */
export default function useCounterAnimation(end, duration = 1500) {
  const [value, setValue] = useState(0);
  const startTimestamp = useRef(null);

  useEffect(() => {
    let animationFrame;
    function animate(timestamp) {
      if (!startTimestamp.current) startTimestamp.current = timestamp;
      const progress = Math.min((timestamp - startTimestamp.current) / duration, 1);
      setValue(Math.floor(progress * end));
      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      } else {
        setValue(end);
      }
    }
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration]);

  return value;
}
